import * as React from 'react';
import { colorsV2 } from 'style/colors-v2';
import { Typography } from 'components/DesignSystemV2/Typography';
import Stars from 'react-star-ratings';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const Rating = props => {
  const { stars, rated, starSize = 18 } = props;

  return (
    <RatingContainer {...props}>
      <Stars
        rating={stars}
        starRatedColor={colorsV2.yellow100}
        starDimension={starSize + 'px'}
        starSpacing="2px"
        numberOfStars={5}
        svgIconViewBox="0 0 16 15"
        svgIconPath="M7.10986 0.801073C7.4814 0.075375 8.51855 0.075375 8.8901 0.801073L10.4602 3.86784C10.6087 4.15787 10.8892 4.35737 11.2119 4.40249L14.6595 4.88449C15.4912 5.00076 15.8178 6.02838 15.2059 6.60352L12.7582 8.90411C12.512 9.13548 12.3993 9.4755 12.4586 9.80809L13.0429 13.0897C13.1875 13.9017 12.3424 14.5298 11.6066 14.1571L8.4518 12.5593C8.16776 12.4155 7.8322 12.4155 7.54816 12.5593L4.39335 14.1571C3.65758 14.5298 2.81243 13.9017 2.95702 13.0897L3.5414 9.80809C3.60063 9.4755 3.48793 9.13548 3.24177 8.90411L0.794072 6.60352C0.182161 6.02838 0.508801 5.00076 1.34048 4.88449L4.78807 4.40249C5.11076 4.35737 5.39123 4.15787 5.53972 3.86784L7.10986 0.801073Z"
        name="rating"
      />

      {rated && (
        <Typography variant="regular/12-20" style={{ color: colorsV2.black60 }}>
          ({rated})
        </Typography>
      )}
    </RatingContainer>
  );
};

Rating.propTypes = {
  stars: PropTypes.number,
  rated: PropTypes.number
};

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  .star-ratings {
    line-height: 0;
  }
`;
